import '@ifca-root/react-component/src/assets/styles/components/totalAmountFooter.scss'
import theme from '@ifca-root/react-component/src/assets/theme'
import { Grid, Tooltip, useMediaQuery, withStyles } from '@material-ui/core'
import AppContext from 'containers/App/Store/AppContext'
import { amtStr } from 'helpers/StringNumberFunction/NumFormatters'
import React, { useContext } from 'react'

export interface TooltipAmountWithContractSumProps {
  data?: any
  trxType?: any
  module?: string
  docAmt?: any
  detail?: boolean
  ContractSum?: any
}

export const TooltipAmountWithContractSum = (
  props: TooltipAmountWithContractSumProps
) => {
  const { data, module, detail, trxType, ContractSum } = props
  const { globalState, dispatch }: any = useContext(AppContext as any)
  const isDesktop = useMediaQuery(theme.breakpoints.up('sm'), {
    defaultMatches: true,
  })

  const AmountTooltip = withStyles({
    tooltip: {
      color: 'white',
      backgroundColor: '#9e9e9e',
    },
    arrow: {
      '&.MuiTooltip-arrow': {
        right: 0,
        color: '#9e9e9e',
        width: '8rem',
      },
    },
  })(Tooltip)

  let itemData = []
  let headerData = []

  itemData = data

  const totalBaseAmt = itemData?.reduce(
    (prevValue, currentValue) =>
      prevValue +
      (module === 'scheduled-billing'
        ? currentValue?.BillingAmt ?? 0
        : currentValue?.Amount ?? 0),
    0
  )
  const totalTaxAmt = itemData?.reduce(
    (prevValue, currentValue) => prevValue + currentValue?.TaxAmt,
    0
  )
  const grandTotalAmt = itemData?.reduce(
    (prevValue, currentValue) => prevValue + currentValue?.DocAmt,
    0
  )

  return (
    <div
      className={detail ? 'totalAmountFooterDetail' : 'totalAmountFooter'}
      style={{
        width:
          isDesktop && globalState.drawerOpen
            ? 'calc(100% - 288px)'
            : !isDesktop
            ? '100%'
            : 'calc(100% - 48px)',
        marginLeft:
          isDesktop && globalState.drawerOpen
            ? '264px'
            : !isDesktop
            ? '0px'
            : '24px',
      }}
    >
      {/* <div>
        <span
          style={{
            fontWeight: 500,
            height: '9px',
            marginLeft: '20px',
            color: 'white',
            float: 'left',
            marginTop: '7px',
            fontSize: '10.5px',
            textDecoration: 'underline',
          }}
        >
          Contract Sum:
          <span
            style={{
              marginLeft: '3px',
            }}
          />
          {amtStr(ContractSum)}
        </span>
      </div> */}
      {/* <AmountTooltip
        onClick={e => e.stopPropagation()}
        title={
          <React.Fragment>
            <Grid container wrap="nowrap" spacing={2}>
              <Grid item xs zeroMinWidth>
                {
                  <div>
                    <div style={{ fontSize: '12px' }}>
                      {`Base Amount: ${amtStr(totalBaseAmt)}`}
                    </div>
                    <div style={{ fontSize: '12px' }}>
                      {`Tax Amount: ${amtStr(totalTaxAmt)}`}
                    </div>
                    <div style={{ fontSize: '12px' }}>
                      {`Grand Total: ${amtStr(grandTotalAmt)}`}
                    </div>
                  </div>
                }
              </Grid>
            </Grid>
          </React.Fragment>
        }
        disableFocusListener
        placement="top-end"
        enterTouchDelay={0}
        arrow
      > */}
      <div>
        <span
          style={{
            fontWeight: 500,
            height: '9px',
            marginLeft: '10px',
            color: 'white',
            float: 'right',
            marginTop: '7px',
            fontSize: '10.5px',
            marginRight: '20px',
            textDecoration: 'underline',
          }}
        >
          Total Schedule Amount:
          <span
            style={{
              marginLeft: '3px',
            }}
          />
          {amtStr(totalBaseAmt)}
        </span>
      </div>
      {/* </AmountTooltip> */}
    </div>
  )
}
